import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "@thilke/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const resourceBarVariants = cva(
  "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
  {
    variants: {
      variant: {
        default: "",
        segmented:
          "[background-image:linear-gradient(to_right,transparent_0,transparent_calc(100%/20-1px),hsl(var(--background)/0.5)_calc(100%/20-1px),hsl(var(--background)/0.5)_calc(100%/20))] [background-size:calc(100%/20)_100%]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

interface ResourceBarProps
  extends React.ComponentProps<typeof ProgressPrimitive.Root>,
    VariantProps<typeof resourceBarVariants> {
  indicatorClassName?: string;
}

function ResourceBar({
  className,
  indicatorClassName,
  value = 0,
  variant,
  ...props
}: ResourceBarProps) {
  const numericValue = value ?? 0;
  const clampedValue = Math.max(0, Math.min(100, numericValue));

  return (
    <ProgressPrimitive.Root
      data-slot="resource-bar"
      className={cn(resourceBarVariants({ variant }), className)}
      value={clampedValue}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="resource-bar-indicator"
        className={cn(
          "h-full w-full bg-primary transition-transform",
          indicatorClassName,
        )}
        style={{ transform: `translateX(-${100 - clampedValue}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export type { ResourceBarProps };
export { ResourceBar, resourceBarVariants };
